import { Link } from 'react-router-dom';
import { Page } from '../components/Page';

export const NotFoundPage = () => (
  <Page>
    <div style={{ textAlign: 'center', padding: '80px 0', color: 'var(--p-muted-fg)' }}>
      <div style={{ fontSize: 48, fontWeight: 700, color: 'var(--p-foreground)', letterSpacing: '-0.02em' }}>404</div>
      <p style={{ fontSize: 14, marginTop: 8 }}>This page doesn't exist.</p>
      <Link to="/" style={{ color: 'var(--p-primary)', fontSize: 14, fontWeight: 500 }}>
        Back to dashboard
      </Link>
    </div>
  </Page>
);
